import { render, staticRenderFns } from "./formModal.vue?vue&type=template&id=92962332&"
import script from "./formModal.vue?vue&type=script&lang=ts&"
export * from "./formModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports